module.exports = "/_next/static/images/TheGrowthReport@2x-2043996a2080657e9b76df6497f4f106.png";